(function () {
  'use strict';
  var form = document.getElementById('O3Calc');
  if (!form || form.dataset.o3Init) return;
  form.dataset.o3Init = '1';

  /* Reference intakes (mg EPA+DHA/day): EFSA/WHO 250-500 baseline; ISSFAL 500 min
     cardio; AHA ~1,000 existing heart concerns; mood research 1,000-2,000 EPA-led;
     training studies 1,500-3,000; TG management 2,000-4,000 clinician-guided;
     pregnancy +200 mg DHA (EFSA/ISSFAL); FAO/WHO child bands; FDA <=3 g/day
     supplemental ceiling.
     Absorption multipliers vs oil-with-fat baseline: ethyl esters absorb markedly
     worse without dietary fat (Davidson 2012; Schuchardt & Hahn 2013); natural/
     re-esterified TG and phospholipid forms are less meal-sensitive (Dyerberg 2010).
     Omega-3 Index model: Western baseline ~4.3% (Stark 2016); ~2.2 index points
     per g/day EPA+DHA approaching steady state over ~3-4 months (Walker 2019),
     first-order kinetics tau ~9 weeks. Estimates, clearly labelled as such. */
  var GOALS = {
    general: { label: 'general health', lo: 250, hi: 500, note: 'EFSA and WHO reference intakes for healthy adults.' },
    heart:   { label: 'heart support', lo: 500, hi: 1000, note: 'ISSFAL minimum for cardiovascular health up to the level long used in AHA guidance for people with existing heart concerns.' },
    brain:   { label: 'brain & cognition', lo: 500, hi: 1000, dha: true, note: 'Cognition studies typically use 500–1,000 mg with an emphasis on DHA.' },
    mood:    { label: 'mood support', lo: 1000, hi: 2000, epa: true, note: 'Mood research uses EPA-predominant formulas at 1,000–2,000 mg — discuss with your clinician alongside any treatment.' },
    sport:   { label: 'joints & training', lo: 1500, hi: 3000, note: 'Doses used in joint-comfort and exercise-recovery research.' },
    tg:      { label: 'triglyceride management', lo: 2000, hi: 4000, rx: true, note: 'This range is prescription territory — only with your clinician\'s supervision.' }
  };
  var STAGES = {
    adult:    {},
    older:    {},
    pregnant: { lo: 450, hi: 700, lock: true, note: 'Pregnancy targets add at least 200 mg of DHA to the adult baseline (EFSA, ISSFAL). Choose a supplement clearly labelled for pregnancy and confirm it with your midwife or doctor.' },
    child48:  { lo: 150, hi: 250, lock: true, kid: true, note: 'Child intakes follow FAO/WHO age-banded guidance. Confirm any supplement with your paediatrician.' },
    child913: { lo: 200, hi: 300, lock: true, kid: true, note: 'Child intakes follow FAO/WHO age-banded guidance. Confirm any supplement with your paediatrician.' },
    teen:     { lo: 250, hi: 500, lock: true, note: 'Teen targets align with adult baseline intakes.' }
  };
  var OILY_MG = 1400, WHITE_MG = 200, SUPP_CAP = 3000;
  var FORM_FACTOR = { ee: 0.75, tg: 1.0, pl: 1.0, unsure: 0.85 };
  var MEAL_FACTOR = {
    with:      { ee: 1.0,  tg: 1.0,  pl: 1.0,  unsure: 1.0 },
    sometimes: { ee: 0.75, tg: 0.92, pl: 0.95, unsure: 0.85 },
    empty:     { ee: 0.5,  tg: 0.85, pl: 0.9,  unsure: 0.7 }
  };

  var goalWrap = document.getElementById('O3GoalWrap');
  form.querySelectorAll('#O3Stage input').forEach(function (r) {
    r.addEventListener('change', function () {
      var locked = !!STAGES[r.value].lock;
      goalWrap.style.opacity = locked ? '0.45' : '';
      goalWrap.querySelectorAll('input').forEach(function (g) { g.disabled = locked; });
      if (locked) form.querySelector('#O3Goal input[value="general"]').checked = true;
    });
  });

  var productSel = document.getElementById('O3Product');
  var customIn = document.getElementById('O3Custom');
  var formSel = document.getElementById('O3Form');
  productSel.addEventListener('change', function () {
    var opt = productSel.options[productSel.selectedIndex];
    if (productSel.value !== 'custom') customIn.value = productSel.value;
    if (opt.dataset.form) formSel.value = opt.dataset.form;
  });

  function fmt(mg) { return mg.toLocaleString('en-US'); }
  function idxFmt(v) { return (Math.round(v * 10) / 10).toFixed(1) + '%'; }

  function drawChart(base, delta, tau) {
    var W = 560, H = 220, L = 40, R = 16, T = 14, B = 30;
    var weeks = 26;
    var yMin = 3, yMax = Math.max(10.5, Math.min(12.5, base + delta + 1));
    function x(w) { return L + (w / weeks) * (W - L - R); }
    function y(v) { return T + (1 - (v - yMin) / (yMax - yMin)) * (H - T - B); }
    function o3i(w) { return base + delta * (1 - Math.exp(-w / tau)); }

    var pts = [];
    for (var w = 0; w <= weeks; w++) pts.push([x(w), y(o3i(w)), w, o3i(w)]);
    var path = pts.map(function (p, i) { return (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' ');

    var gridlines = '', axis = '';
    for (var v = 4; v <= yMax; v += 2) {
      gridlines += '<line class="o3chart__grid" x1="' + L + '" y1="' + y(v) + '" x2="' + (W - R) + '" y2="' + y(v) + '"/>';
      axis += '<text class="o3chart__axis" x="' + (L - 6) + '" y="' + (y(v) + 3) + '" text-anchor="end">' + v + '%</text>';
    }
    [0, 8, 16, 26].forEach(function (w) {
      axis += '<text class="o3chart__axis" x="' + x(w) + '" y="' + (H - 10) + '" text-anchor="middle">' + (w === 0 ? 'now' : 'wk ' + w) + '</text>';
    });

    var thresh = '';
    if (yMax > 8) {
      thresh = '<line class="o3chart__thresh" x1="' + L + '" y1="' + y(8) + '" x2="' + (W - R) + '" y2="' + y(8) + '"/>' +
        '<text class="o3chart__threshlabel" x="' + (W - R) + '" y="' + (y(8) - 5) + '" text-anchor="end">8% — protective zone begins</text>';
    }

    var cross = '';
    var end = base + delta;
    if (end >= 8 && base < 8 && delta > 0) {
      var tw = -tau * Math.log(1 - (8 - base) / delta);
      if (tw > 0 && tw <= weeks) {
        cross = '<circle class="o3chart__dot" cx="' + x(tw) + '" cy="' + y(8) + '" r="4.5"/>';
      }
    }
    var endLabel = '<circle class="o3chart__dot" cx="' + x(weeks) + '" cy="' + y(o3i(weeks)) + '" r="4"/>' +
      '<text class="o3chart__endlabel" x="' + (x(weeks) - 8) + '" y="' + (y(o3i(weeks)) - 9) + '" text-anchor="end">' + (delta > 0.05 ? 'with plan: ' : 'steady: ') + idxFmt(o3i(weeks)) + '</text>';
    var baseLine = '';
    if (delta > 0.05) {
      baseLine = '<line class="o3chart__base" x1="' + L + '" y1="' + y(base) + '" x2="' + (W - R) + '" y2="' + y(base) + '"/>' +
        '<text class="o3chart__baselabel" x="' + (W - R) + '" y="' + (y(base) + 14) + '" text-anchor="end">without: ' + idxFmt(base) + '</text>';
    }

    var svg = '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Projected Omega-3 Index over 26 weeks, from ' +
      idxFmt(base) + ' toward ' + idxFmt(end) + '">' + gridlines + thresh + axis +
      baseLine + '<path class="o3chart__line" d="' + path + '"/>' + cross + endLabel + '</svg>';

    var wrap = document.getElementById('O3Chart');
    wrap.innerHTML = svg;

    var tip = document.getElementById('O3Tip');
    var svgEl = wrap.querySelector('svg');
    svgEl.addEventListener('mousemove', function (e) {
      var rect = svgEl.getBoundingClientRect();
      var w = Math.round(((e.clientX - rect.left) / rect.width * W - L) / (W - L - R) * weeks);
      if (w < 0 || w > weeks) { tip.style.display = 'none'; return; }
      tip.textContent = 'Week ' + w + ': ~' + idxFmt(o3i(w));
      tip.style.display = 'block';
      tip.style.left = (x(w) / W * rect.width) + 'px';
      tip.style.top = (y(o3i(w)) / H * rect.height) + 'px';
    }, { passive: true });
    svgEl.addEventListener('mouseleave', function () { tip.style.display = 'none'; }, { passive: true });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var stageKey = form.querySelector('#O3Stage input:checked').value;
    var goalKey = form.querySelector('#O3Goal input:checked').value;
    var stage = STAGES[stageKey];
    var goal = GOALS[goalKey];

    var lo = stage.lock ? stage.lo : goal.lo;
    var hi = stage.lock ? stage.hi : goal.hi;

    var oily = Math.max(0, parseInt(document.getElementById('O3Oily').value || '0', 10));
    var white = Math.max(0, parseInt(document.getElementById('O3White').value || '0', 10));
    var diet = Math.round((oily * OILY_MG + white * WHITE_MG) / 7);

    var gapLo = Math.max(0, lo - diet);
    var gapHi = Math.max(0, hi - diet);

    var labelMg = Math.max(1, parseInt(customIn.value || '300', 10));
    var formKey = formSel.value;
    var mealKey = form.querySelector('#O3Meal input:checked').value;
    var factor = FORM_FACTOR[formKey] * MEAL_FACTOR[mealKey][formKey];
    var effective = Math.max(1, Math.round(labelMg * factor));
    var lossPct = Math.round((1 - factor) * 100);

    var maxCaps = Math.max(1, Math.floor(SUPP_CAP / labelMg));
    var wantHi = Math.ceil(gapHi / effective);
    var capped = gapHi > 0 && wantHi > maxCaps;
    var capsLo = Math.min(Math.ceil(gapLo / effective), maxCaps);
    var capsHi = Math.min(wantHi, maxCaps);

    document.getElementById('O3Target').innerHTML = fmt(lo) + '–' + fmt(hi) + ' <small>mg/day</small>';
    document.getElementById('O3TargetNote').textContent = stage.lock ? (stage.note || '') : 'For ' + goal.label + '. ' + goal.note;
    document.getElementById('O3Caps').innerHTML = gapHi === 0 ? 'covered by diet'
      : (capsLo === capsHi ? capsHi : capsLo + '–' + capsHi) + ' <small>softgel' + (capsHi === 1 ? '' : 's') + '/day</small>';
    document.getElementById('O3CapsNote').textContent = gapHi === 0 ? '' : 'absorption-adjusted for your form and meal habits';

    document.getElementById('O3RowTarget').textContent = fmt(lo) + '–' + fmt(hi) + ' mg/day';
    document.getElementById('O3RowDiet').textContent = '≈ ' + fmt(diet) + ' mg/day';
    document.getElementById('O3RowGap').textContent = gapHi === 0 ? '0 mg — diet covers it' : fmt(gapLo) + '–' + fmt(gapHi) + ' mg/day';
    document.getElementById('O3RowAbsorb').textContent = fmt(labelMg) + ' mg on the label → ≈ ' + fmt(effective) + ' mg absorbed';

    /* Omega-3 Index model — estimates for adults; hidden for children */
    var showIndex = !stage.kid;
    var baseIdx = Math.min(9, 4.0 + oily * 0.5 + white * 0.05);
    var capsMid = gapHi === 0 ? 0 : Math.max(capsLo, Math.round((capsLo + capsHi) / 2), 1);
    var suppG = (capsMid * effective) / 1000;
    var delta = Math.min(12 - baseIdx, suppG * 2.2 + (gapHi === 0 ? 0 : 0));
    var endIdx = baseIdx + delta;
    var TAU = 9;
    document.getElementById('O3RowIndexNow').textContent = showIndex ? '≈ ' + idxFmt(baseIdx) + ' (modelled)' : 'n/a for children';
    document.getElementById('O3RowIndexProj').textContent = showIndex ? '≈ ' + idxFmt(endIdx) + ' after ~6 months (+' + (Math.round((endIdx - baseIdx) * 10) / 10).toFixed(1) + ' pts)' : 'n/a for children';
    document.getElementById('O3ChartWrap').style.display = showIndex ? '' : 'none';
    if (showIndex) {
      document.getElementById('O3ChartSub').textContent =
        (suppG > 0 ? 'Modelled at ' + capsMid + ' softgel' + (capsMid === 1 ? '' : 's') + '/day of your supplement, from published dose-response data (Walker et al., 2019). '
                   : 'Modelled from published dose-response data (Walker et al., 2019). ') +
        'The 8–12% zone is associated with the lowest cardiovascular risk (Harris & von Schacky). Only a blood test can measure your real index.';
      drawChart(baseIdx, delta, TAU);
    }

    var notes = [];
    if (gapHi === 0) notes.push({ t: 'Your fish intake already reaches this target — a supplement is optional insurance rather than a necessity.' });
    if (lossPct >= 20 && gapHi > 0) {
      var fixText = mealKey === 'with'
        ? 'Ethyl-ester oils lose the most to poor absorption — a triglyceride or phospholipid form delivers more of what the label promises.'
        : 'You\'re losing roughly ' + lossPct + '% of your labelled dose to form and timing. The cheapest upgrade: take it with your largest, fattiest meal of the day.';
      notes.push({ t: fixText });
    }
    if (showIndex && endIdx >= 8 && baseIdx < 8 && delta > 0) {
      var tw = Math.round(-TAU * Math.log(1 - (8 - baseIdx) / delta));
      if (tw > 0 && tw <= 26) notes.push({ t: 'At this dose, the model projects you crossing into the 8%+ protective zone around week ' + tw + '. Consistency is the whole game.' });
    } else if (showIndex && endIdx < 8 && gapHi > 0) {
      notes.push({ t: 'The model projects this dose plateauing below the 8% protective zone. Reaching it would take a higher intake — or confirm where you actually stand with a dried-blood-spot Omega-3 Index test first.' });
    }
    if (!stage.lock && goal.dha) notes.push({ t: 'For this goal, favour a formula with a higher share of DHA — check the label split.' });
    if (!stage.lock && goal.epa) notes.push({ t: 'Mood research leans on EPA — look for a formula where EPA clearly outweighs DHA.' });
    if (stageKey === 'pregnant') notes.push({ t: 'Make sure at least 200 mg of your daily total is DHA specifically.' });
    if (stage.lock && stage.note && stageKey !== 'pregnant') notes.push({ t: stage.note });
    if (!stage.lock && goal.rx) notes.push({ t: goal.note, warn: true });
    if (capped) notes.push({ t: 'Closing the full gap for this goal would take more than the FDA\'s guidance of 3,000 mg supplemental EPA+DHA per day. The plan and projection above are capped at that ceiling — going beyond it is a decision for your clinician, not a calculator.', warn: true });

    document.getElementById('O3Notes').innerHTML = notes.map(function (n) {
      return '<div class="o3c__note' + (n.warn ? ' o3c__note--warn' : '') + '">' + n.t + '</div>';
    }).join('');

    document.getElementById('O3Result').classList.add('is-visible');
    document.getElementById('O3Result').scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    form.dataset.summary = 'My omega-3 numbers: target ' + fmt(lo) + '-' + fmt(hi) + ' mg EPA+DHA/day, ~' + fmt(diet) +
      ' mg from diet. My ' + fmt(labelMg) + ' mg softgel really delivers ~' + fmt(effective) + ' mg absorbed' +
      (showIndex ? '. Projected Omega-3 Index: ' + idxFmt(baseIdx) + ' → ' + idxFmt(endIdx) : '') +
      '. Via the SAP Nutra omega-3 calculator: ' + window.location.href;
  });

  document.getElementById('O3Copy').addEventListener('click', function () {
    if (!form.dataset.summary) return;
    navigator.clipboard.writeText(form.dataset.summary).then(function () {
      var copied = document.getElementById('O3Copied');
      copied.style.display = 'inline';
      setTimeout(function () { copied.style.display = 'none'; }, 2500);
    });
  });
})();
